import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { notification } from 'antd';
import moment from 'moment';
import axios from 'axios';
import { useSelector } from 'react-redux';

import { IOrgao } from './interfaces';
import { stateGlobal } from '../../../interfaces/Global';

import { useGetColumnSearchPropsData } from '../../../hooks/FilterTable/date';
import { useGetColumnSearchProps } from '../../../hooks/FilterTable/stringCLearFiltros';
import OrgaoService from '../../../services/http/services/SaldoDeContas/OrgaoService';

export const useOrgaos = () => {
    const refContagemDoFiltro = React.useRef<Array<any>>([]);

    const propsState = useSelector((state: stateGlobal) => state.global);

    const history = useHistory();

    const signal = axios.CancelToken.source();

    const [selectedRowKeys, setSelectedRowKeys] = useState<Array<number>>([]);
    const [dadosTabelaState, setDadosTabelaState] = useState<IOrgao[]>([]);
    const [hasSelectedEdit, setHasSelectedEdit] = useState(false);
    const [loadingTable, setLoadingTable] = useState(true);

    const loadData = useCallback(() => {

        const loadOrgaos = async () => {
            try {
                setLoadingTable(true);
                const data = await OrgaoService.getOrgaos(signal.token);

                setDadosTabelaState(data);
                setLoadingTable(false);
            } catch (error) {
                let msgErro: any = (error as Error);
                if (msgErro?.message != 'Requisicao cancelada!') {
                    setLoadingTable(false)
                    notification.error({
                        message: 'Erro',
                        description:
                            'Não foi possivel buscar os dados!',
                    });
                }
            }
        }

        loadOrgaos();
    }, []);

    useEffect(() => {
        loadData();

        return () => {
            signal.cancel("Requisicao cancelada!")
        }
    }, []);

    const clickBotaoEditarUsuario = useCallback((): void => {
        if (selectedRowKeys.length == 1) {
            history.push(`/ativacoes/manutencao/${selectedRowKeys[0]}`);
        }
    }, [selectedRowKeys]);

    const handleResetRowSelection = useCallback(() => {
        setSelectedRowKeys([]);
        setHasSelectedEdit(false);
    }, []);

    const onclickTable = useCallback((record: IOrgao, row: any): void => {

        if (selectedRowKeys.includes(record.id)) {
            let filter = selectedRowKeys.filter((val) => {
                return val != record.id
            })
            if (filter.length === 1) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(true);
            } else if (filter.length === 0) {
                setSelectedRowKeys(filter);
                setHasSelectedEdit(false);
            } else {
                setSelectedRowKeys(filter);
            }

        } else {
            if (selectedRowKeys.length == 0) {
                setSelectedRowKeys([record.id]);
                setHasSelectedEdit(true);
            } else {
                setSelectedRowKeys([record.id]);
                setHasSelectedEdit(true);
            }
        }
    }, [selectedRowKeys]);

    const onSelectChange = useCallback((selectedRowKeys): void => {
        if (selectedRowKeys.length > 1) {
            setSelectedRowKeys([selectedRowKeys[1]]);
            setHasSelectedEdit(true);
        } else if (selectedRowKeys.length === 0) {
            setSelectedRowKeys(selectedRowKeys);
            setHasSelectedEdit(false);
        } else {
            setSelectedRowKeys([selectedRowKeys[0]]);
            setHasSelectedEdit(true);
        }
    }, [selectedRowKeys]);

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        columnWidth: '1%',
        type: 'radio' as any
    };

    const refFuncaoLimparFiltrosStringNome = useRef<any>(null);
    const columnSearchPropsNome = useGetColumnSearchProps('nome', refFuncaoLimparFiltrosStringNome);

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'nome',
            ...columnSearchPropsNome,
            width: '10%',
            sorter: (a: any, b: any) => a.nome.localeCompare(b.nome),
            showSorterTooltip: false,
        },
        {
            title: 'Criado em',
            dataIndex: 'createdAt',
            ...useGetColumnSearchPropsData('createdAt'),
            width: '2%',
            sorter: (a: any, b: any) => {

                let aMonMen: any = null
                let bMonMen: any = null
                if (a.createdAt) {
                    aMonMen = moment(a.createdAt).unix()
                } else {
                    aMonMen = 0
                }
                if (b.createdAt) {
                    bMonMen = moment(b.createdAt).unix()
                } else {
                    bMonMen = 0
                }

                return aMonMen - bMonMen
            },
            showSorterTooltip: false,
            render: (criado: any) => (
                moment(criado).format('DD/MM/YYYY HH:mm')
            ),
        },
    ];

    return {
        clickBotaoEditarUsuario,
        hasSelectedEdit,
        loadingTable,
        onclickTable,
        rowSelection,
        dadosTabelaState,
        columns,
        refContagemDoFiltro,
        propsState,
        handleResetRowSelection,
    }
}
